import api from '../../api'
import { Enum, PricingType } from '../../../common/constants'

export const markUnbillableEndpoint = '/web/admin/mark-unbillable'
export const resolveInvoicedLinesEndpoint = `${markUnbillableEndpoint}/invoiced-lines`
export const discrepancyJobsEndpoint = `${markUnbillableEndpoint}/jobs`
export const matchBilledPriceEndpoint = `${markUnbillableEndpoint}/repriced-lines`

export const InvoicedLineKinds = { Item: 0, Labor: 1 } as const
export type InvoicedLineKind = Enum<typeof InvoicedLineKinds>

export const InvoicedLineResolutions = { WriteOff: 0, Bill: 1 } as const
export type InvoicedLineResolution = Enum<typeof InvoicedLineResolutions>

export type UnbilledWorkRequest = {
  tenantId: number
  jobId: number
}

export type UnbilledLine = {
  itemId: string
  name: string
  quantity: number
  units: string
  visitDate: string | null
  amount: number
}

export type UnbilledWorkarea = {
  workareaId: number
  workareaName: string
  groupName: string
  pricingType: PricingType
  items: UnbilledLine[]
  labor: UnbilledLine[]
  total: number
}

export type InvoicedLine = {
  lineId: string
  kind: InvoicedLineKind
  workareaId: number
  workareaName: string
  groupName: string
  name: string
  quantity: number
  units: string
  visitDate: string | null
  amount: number
  billedAmount: number
  invoiceNumbers: string[]
}

export type UnbilledWorkResult = {
  jobId: number
  workareas: UnbilledWorkarea[]
  unchargedLines: InvoicedLine[]
  repricedLines: InvoicedLine[]
}

export type DiscrepancyJob = {
  id: number
  name: string
  customerName: string
  unchargedAmount: number
  unchargedLineCount: number
  repricedLineCount: number
  repricedDifference: number
}

export type MarkUnbillableRequest = {
  tenantId: number
  jobId: number
  workareaIds: number[]
}

export type InvoicedLineChoice = {
  lineId: string
  resolution: InvoicedLineResolution
}

export type ResolveInvoicedLinesRequest = {
  tenantId: number
  jobId: number
  lines: InvoicedLineChoice[]
}

export type MatchBilledPriceRequest = {
  tenantId: number
  jobId: number
  lineIds: string[]
}

export const getUnbilledWork = async (request: UnbilledWorkRequest): Promise<UnbilledWorkResult> => {
  return (await api.get(markUnbillableEndpoint, { params: request })).data
}

export const getDiscrepancyJobs = async (tenantId: number): Promise<DiscrepancyJob[]> => {
  return (await api.get(discrepancyJobsEndpoint, { params: { tenantId } })).data
}

export const markWorkUnbillable = async (request: MarkUnbillableRequest): Promise<void> => {
  await api.post(markUnbillableEndpoint, request)
}

export const resolveInvoicedLines = async (request: ResolveInvoicedLinesRequest): Promise<void> => {
  await api.post(resolveInvoicedLinesEndpoint, request)
}

export const matchBilledPrice = async (request: MatchBilledPriceRequest): Promise<void> => {
  await api.post(matchBilledPriceEndpoint, request)
}
